import L from "leaflet";
import { Marker, Tooltip } from "react-leaflet";

const handle = (size, fill, opacity = 1) => L.divIcon({
  className: "",
  html: `<div style="width:${size}px;height:${size}px;background:${fill};opacity:${opacity};border:2px solid #0b1329;border-radius:3px;box-shadow:0 0 0 2px #38bdf8;cursor:grab"></div>`,
  iconSize: [size, size], iconAnchor: [size / 2, size / 2],
});
const VERTEX = handle(12, "#ffffff");
const MID = handle(9, "#38bdf8", 0.75);

const ll = (e) => [+e.target.getLatLng().lat.toFixed(6), +e.target.getLatLng().lng.toFixed(6)];

export const VertexEditor = ({ el, onChange }) => {
  if (!el?.coords?.length || el.kind === "cut_point" || (el.kind === "sign" && el.sign_type !== "valla_linea")) return null;
  const closed = el.kind === "no_parking";
  const min = closed ? 3 : 2;
  const c = el.coords;
  const set = (coords) => onChange({ ...el, coords });
  const mids = c.map((p, i) => {
    const q = c[i + 1] || (closed ? c[0] : null);
    return q ? { i, p: [(p[0] + q[0]) / 2, (p[1] + q[1]) / 2] } : null;
  }).filter(Boolean);

  return (
    <>
      {c.map((p, i) => (
        <Marker key={`v-${el.id}-${i}-${p[0]}-${p[1]}`} position={p} icon={VERTEX} draggable zIndexOffset={2000} data-testid={`vertex-handle-${i}`}
          eventHandlers={{
            dragend: (e) => set(c.map((x, j) => (j === i ? ll(e) : x))),
            contextmenu: () => c.length > min && set(c.filter((_, j) => j !== i)),
            click: (e) => L.DomEvent.stopPropagation(e),
          }}>
          <Tooltip direction="top" offset={[0, -6]}>Arrastrar para mover · clic derecho para borrar</Tooltip>
        </Marker>
      ))}
      {mids.map(({ i, p }) => (
        <Marker key={`m-${el.id}-${i}-${p[0]}-${p[1]}`} position={p} icon={MID} draggable zIndexOffset={1900}
          eventHandlers={{
            dragend: (e) => set([...c.slice(0, i + 1), ll(e), ...c.slice(i + 1)]),
            click: (e) => L.DomEvent.stopPropagation(e),
          }}>
          <Tooltip direction="top" offset={[0, -6]}>Arrastrar para añadir un punto</Tooltip>
        </Marker>
      ))}
    </>
  );
};
